// extracted by mini-css-extract-plugin
export default {"signature-wrapper":"Signature_signature-wrapper__UurJp"};